import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'Common/Spinner';
import ActionButton from 'Common/Buttons/ActionButton';

import Page from 'Common/Layout/Page';
import Section from 'Common/Layout/Section';
import SuccessFailure from 'Common/Components/success-failure/SuccessFailure.container';

import ConfirmCancel from 'Common/Components/ConfirmModal/ConfirmModal';
import ContractChecklist from '../ContractChecklist/ContractChecklist.container';
import classes from './CheckPDF.module.css';
import { makeStyles } from 'utils';

const styles = makeStyles(classes);

const CheckPDFView = ({
    title,
    pdf,
    isLoading,
    isSuccess,
    isFail,
    isChecking,
    handlePDFChecked,
    handleClosedPDF,
    grouping,
    showModal,
    handleCancelConfirmed,
    handleCancelWithdrawn,
    updateCheckedCount
}) => {

    return (
        <Page title={title} fitScreen size="small">
            <Section grow>
                <h3 class="sr-only">Check PDF</h3>
                <div className={styles('container')}>
                    {isChecking && (
                        <div className={styles('checklist')}>
                            <ContractChecklist
                                grouping={grouping}
                                handlePDFChecked={handlePDFChecked}
                                updateCheckedCount={updateCheckedCount}
                            />
                        </div>
                    )}

                    <div className={isChecking ? styles('checking-pdf') : styles('viewing-pdf')}>
                        {isLoading && (
                            <Spinner />
                        )}

                        {isFail && (
                            <SuccessFailure hasResult={true} result={false} failMessage="Unable to retrieve the pdf" />
                        )}

                        {isSuccess && (
                            <object className={styles('pdf')} aria-label="appointment pdf" type="application/pdf" data={`data:application/pdf;base64,${pdf}`}>
                                PDF Document
                            </object>
                        )}
                    </div>
                </div>
            </Section>
            <ActionButton text="Close" onClick={handleClosedPDF} variant="secondary" containerClass={styles('close-button')} />
            <ConfirmCancel 
                isOpen={showModal} 
                heading="Cancel Checking of Appointment"
                message="If you close this view, all your checks will be lost. Do you wish to proceed and cancel your checks?"
                onProceed={handleCancelConfirmed}
                onWithdraw={handleCancelWithdrawn}
            />
        </Page>
    );
};

CheckPDFView.propTypes = {
    title: PropTypes.string.isRequired,
    pdf: PropTypes.any,
    isLoading: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    isFail: PropTypes.bool.isRequired,
    isChecking: PropTypes.bool.isRequired,
    handlePDFChecked: PropTypes.func.isRequired,
    handleClosedPDF: PropTypes.func.isRequired,
    grouping: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
    handleCancelConfirmed: PropTypes.func.isRequired,
    handleCancelWithdrawn: PropTypes.func.isRequired,
    updateCheckedCount: PropTypes.func.isRequired
};

export default CheckPDFView;

